import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';
import { StyledStorybook } from './Storybook.styles';
import { useStorybookContext } from '../../../Context/AppProvider';

const CustomTooltip = ({
  continuous,
  index,
  isLastStep,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps
}) => {
  const {
    state: { stepIndex, steps },
  } = useStorybookContext();

  const backDisabled = backProps?.disabled;
  const nextDisabled = primaryProps?.disabled;

  return (
    <StyledStorybook
      {...tooltipProps}
    >
      {step.content}

      <div
        className='footer'
      >
        {skipProps && (
          <button
            {...skipProps}
            className='skip-button'
          >
            Skip
          </button>
        )}
        <div className="dots-holder">
          {steps?.map((_, index) => (

            <div key={index} className={stepIndex === index ? 'dot active' : 'dot'} />
          )
          )}
        </div>
        <div
          className='footer-buttons'
        >
          {index > 0 && (
            <button
              {...backProps}
              className={`back-button ${!backDisabled ? 'back-button--enabled' : ''}`}

            >
              <IoIosArrowRoundBack size={30} />
            </button>
          )}

          <button
            {...primaryProps}
            className={`next-button ${!nextDisabled ? 'next-button--enabled' : ''} ${isLastStep ? 'finish-button' : ''
              }`}
          >
            {isLastStep ? (
              'Finish'
            ) : (
              <IoIosArrowRoundForward size={30} />
            )}
          </button>
        </div>
      </div>
    </StyledStorybook>
  );
};
export default CustomTooltip;